import styled from 'styled-components'

export const AppWrapper = styled.div`
  background: ${(props): any => props.theme.mainBackground};
`

export const MainContent = styled.section`
  padding-top: 64px;
`
